import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '../../../../lib/auth.service';

@Component({
  selector: 'app-reset-password-link',
  templateUrl: './reset-password-link.component.html',
  styleUrls: ['./reset-password-link.component.scss'],
})
export class ResetPasswordLinkComponent {
  @Input() email = '';
  @Input() disabled = false;
  @Input() label = 'パスワードを忘れてしまったら';
  @Output() completed = new EventEmitter<void>();
  @Output() failed = new EventEmitter<string>();

  showSendMailConfirmModal = false;
  showSendMailFinishedModal = false;
  loading = false;

  constructor(private readonly authService: AuthService) {}

  onClickLink() {
    if (this.disabled) {
      return;
    }

    this.showSendMailConfirmModal = true;
  }

  async onConfirmSendResetMail() {
    this.showSendMailConfirmModal = false;
    this.loading = true;

    try {
      await this.authService.sendPasswordResetMail(this.email);
      this.loading = false;
      this.showSendMailFinishedModal = true;
    } catch (e) {
      this.loading = false;
      if (e.code === 'auth/user-not-found') {
        this.failed.emit('登録されていないメールアドレスです。');
        return;
      }

      this.failed.emit('エラーが発生しました。');
    }
  }

  onCancelSendResetMail() {
    this.showSendMailConfirmModal = false;
  }

  onClickConfirmModal() {
    this.completed.emit();
    this.showSendMailFinishedModal = false;
  }
}
